import React, { useContext, useState } from "react";
import {
  BrowserRouter as Router, Navigate, Route, Routes
} from "react-router-dom";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import "./App.css";
import { Navbar, NoContent } from "./components";
import CustomSnackbar from "./components/CustomSnackbar";
import { About, CustomWall, EmptyWall, Gallery, Home, Page404 } from './pages';

export const getRoutes = () => {
  return [
    {
      path: "/",
      element: <Navigate to="/home" />,
    },
    {
      path: 'home',
      element: <Home />
    },
    {
      path: "about",
      element: <About />,
    },
    {
      path: "wall",
      children: [
        {
          childPath: "",
          childElement: <Gallery />,
        },
        {
          childPath: "empty",
          childElement: <EmptyWall />,
          hideNavbar: true,
        },
      ],
    },
    {
      path: 'empty-wall', children: [
        {
          childPath: ':address', childElement: <NoContent />, hideNavbar: true
        }
      ]
    },
    {
      path: 'custom/:address/:name',
      element: <CustomWall />
    }
  ];
};

export const wallContext = React.createContext();
export const useWall = () => useContext(wallContext);

const WallProvider = ({ children, content }) => {
  return (
    <wallContext.Provider value={content}>{children}</wallContext.Provider>
  );
};

const Wall = ({ children }) => {
  const [mobile] = useState(window.innerWidth <= 768);
  const [nfts, setNfts] = useState();
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    show: false,
    severity: "warning",
    content: "",
    position: {
      vertical: "top",
      horizontal: "right",
    },
  });
  const [walletAddress, setWalletAddress] = useState('');
  const [customAddress, setCustomAddress] = useState('');

  const content = {
    nfts,
    setNfts,
    loading,
    setLoading,
    setSnackbar,
    snackbar,
    walletAddress,
    setWalletAddress,
    mobile,
    setCustomAddress,
    customAddress,
  };

  return <WallProvider content={content}>{children}</WallProvider>;
};

function App() {
  const [routes] = useState(getRoutes());
  const theme = createTheme({
    palette: {
      primary: {
        main: "#7f77e0",
      },
      secondary: {
        main: "#7F81E026",
      },
    },
  });

  return (
    <Wall>
      <ThemeProvider theme={theme}>
        <Router>
          <Navbar />
          <CustomSnackbar />
          <Routes>
            {routes.map(({ path, element, children }, index) => {
              return children === undefined ? (
                <Route path={path} element={element} key={`route-${index}`} />
              ) : (
                <Route path={path} key={`route-${index}`}>
                  {children.map(({ childPath, childElement }, subIndex) => {
                    return (
                      <Route
                        path={childPath}
                        element={childElement}
                        key={`subroute-${subIndex}`}
                      />
                    );
                  })}
                </Route>
              );
            })}
            <Route path="*" element={<Page404 />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </Wall>
  );
}

export default App;
